import React from "react";
import { Colors } from "../../utils/colors";
import { observer } from "mobx-react-lite";
import { usePaymentStore } from "../../stores/StoreContext";
import { RadioButton } from "../radioButton/RadioButton";
import { TCText } from "../TCText/TCText";
import { BookingPaymentType } from "../../utils/data";

type props = {};

export const ExternalWalletPayment: React.FC<props> = observer(() => {
  const paymentStore = usePaymentStore();

  return (
    <div
      style={{
        border: `2px solid ${Colors.green}`,
        width: "100%",
        display: "flex",
        padding: "15px 20px",
        borderRadius: 20,
        marginBottom: 20,
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      <div>
        <TCText
          style={{ color: Colors.green, fontWeight: 600, fontSize: 15 }}
          value="Pay with club credits"
        />
        <TCText
          style={{ color: Colors.green, fontWeight: 600, fontSize: 15 }}
          value={`Balance : ${paymentStore.extWalletBalance?.balance}`}
        />
      </div>
      <RadioButton
        selected={
          paymentStore.selectedPaymentMethod ===
          BookingPaymentType.EXTERNAL_WALLET
        }
        onChange={() => {
          if (
            paymentStore.selectedPaymentMethod ===
            BookingPaymentType.EXTERNAL_WALLET
          ) {
            paymentStore.setSelectedPaymentMethod(BookingPaymentType.CARD);
          } else {
            paymentStore.setSelectedPaymentMethod(
              BookingPaymentType.EXTERNAL_WALLET
            );
          }
        }}
      />
    </div>
  );
});
